var map = {
	"./artisan": 2,
	"./artisan.png": 2,
	"./big-w": 3,
	"./big-w.svg": 3,
	"./burger": 4,
	"./burger.svg": 4,
	"./email": 5,
	"./email.svg": 5,
	"./expand": 6,
	"./expand.svg": 6,
	"./facebook": 7,
	"./facebook.svg": 7,
	"./favicon": 8,
	"./favicon.svg": 8,
	"./hero": 9,
	"./hero.jpg": 9,
	"./kitchen": 10,
	"./kitchen.jpg": 10,
	"./left-arrow": 11,
	"./left-arrow.svg": 11,
	"./logo": 12,
	"./logo.svg": 12,
	"./marker": 13,
	"./marker.svg": 13,
	"./nav-arrow": 14,
	"./nav-arrow.svg": 14,
	"./open-graph-image": 15,
	"./open-graph-image.jpg": 15,
	"./phone": 16,
	"./phone.svg": 16,
	"./sink": 17,
	"./sink.jpg": 17,
	"./van": 18,
	"./van.jpg": 18,
	"./wood-for-stone": 19,
	"./wood-for-stone.png": 19
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 26;